import React from 'react';
import './LandingPage.css';

const LandingPage = () => {
  const services = [
    "איתור נזילות ונזקי איטום",
    "ייעוץ ומתן מפרטי איטום וחוות דעת לבתי המשפט בתחום האיטום",
    "איטום יריעות ביטומניות",
    "זיפות וסיוד בזפת חם",
    "איטום חדרים רטובים כמו מקלחת ושירותים",
    "איטום בהתזה וביריעות P.V.C",
    "ועוד"
  ];

  return (
    <div className="landing-container" dir="rtl">
      {/* שכבת הרקע עם הבניינים והצבע הכחול */}
      <div className="background-overlay"></div>
      
      {/* תוכן הדף הממורכז */}
      <div className="content-wrapper">
            <h1 style={{ color: "white" }} className="main-heading">
קבלן ויועץ שיקום מבנים עבודות איטום בסנפלינג! 
        </h1>
        <h1 style={{ color: "white" }} className="main-heading">
          מתמחים בייעוץ וביצוע עבודות איטום ועבודות סנפלינג.
          <span className="sub-heading">שירות מקצועי ואמין!</span>
        </h1>

        <p className="description-paragraph">
          חברת איטומים בגבהים מספקת את שירותיה למגזר הפרטי, קבלני בנייה, ועדי בניין, חברות ניהול, קבלני שיפוצים ועוד.
        </p>

        <p className="description-sub">
          צוותי עובדים מקצועיים בעלי ידע רב בתחום עבודות האיטום והסנפלינג הנותנים מגוון שירותים:
        </p>

        {/* רשימת הבולטים המיושרת לשמאל/מרכז עם נקודות בימין */}
        <ul className="services-list-centered">
          {services.map((service, index) => (
            <li key={index} className="service-bullet-item">
              <span className="bullet-point">•</span>
              <span className="bullet-text">{service}</span>
            </li>
          ))}
        </ul>

        <p className="promise-text">
          אנו מתחייבים לתת לכל לקוח שירות אדיב ומקצועי תוך יישום פתרונות מתאימים לצרכי הלקוח.
        </p>

        <div className="call-to-action-section">
          <p className="cta-highlight">
            לפני שאתם בוחרים בעל מקצוע, בדקו טוב שהוא אמין ומקצועי!
          </p>
          <p className="cta-highlight">
            אל תתנו לאף אחד לעשות כסף קל על הגג שלכם...
          </p>
        </div>

      </div>
    </div>
  );
};

export default LandingPage;
